import React, {useState, useEffect} from 'react'
import {Link} from "react-router-dom";

import withLanguage from "../../HOC/withLanguage";
// import E-Albania.svg.png



const EmploymentFilter = ({ language }) => {

    return (

        <section className=" flex-1">


            {/* Filters */}
            <h2 className="text-[20px] mb-6">
                {language.Text1}
            </h2>




            <div className="max-w-6xl mx-auto px-6 mt-16">
                <h2 className="text-center font-semibold text-2xl mb-4">
                    {language.Title1}
                </h2>
            </div>


            <div className="flex justify-center mb-[55px]">
                <input
                    type="text"
                    placeholder={language.search}
                    className="border border-red-700 px-4 py-2 w-full rounded-l-3xl focus:outline-none"
                />

                <a href="https://www.puna.gov.al/kerko" className="bg-red-600 text-white px-8 w-[175px] rounded-r-2xl hover:bg-red-700 flex justify-center items-center">
                    {language.button1}
                </a>
            </div>





            <div>

                <section className="max-w-6xl mx-auto">

                    <h1 className="text-xl font-extrabold text-red-600 mb-4">
                        {language.title2}
                    </h1>


                    <div className="border-2 border-red-500 rounded-3xl p-6 mb-8">

                        <div className="flex gap-4 items-start">

                            <img
                                src="/dual/Picture4.png"
                                alt="Description"
                                className="w-[120px] h-[82px]"
                            />

                            <div>
                                <p className="text-red-600 font-extrabold text-lg">
                                    {language.title3}
                                </p>
                                <p className="mt-1">
                                    {language.subTitle1}
                                </p>


                                <div className="flex justify-end font-semibold text-md">
                                    <a
                                        href="https://e-albania.al/eAlbaniaServices/UseService.aspx?service_code=12550"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center gap-3 bg-red-600 text-white pl-2 px-4 py-1.5 rounded-2xl"
                                    >
                                        <img
                                            src="/dual/eAlbania_logo.867c8fb3.svg"
                                            alt="Apply icon"
                                            className="w-7 h-7"
                                        />
                                        {language.button2}
                                    </a>
                                </div>
                            </div>

                        </div>

                    </div>



                    <div className="border-2 border-red-500 rounded-3xl p-6 mb-8">

                        <div className="flex gap-4 items-start">

                            <img
                                src="/dual/Picture4.png"
                                alt="Description"
                                className="w-[120px] h-[82px]"
                            />


                            <div>
                                <p className="text-red-600 font-extrabold text-lg">
                                    {language.title4}
                                </p>
                                <p className="mt-1">
                                    {language.subTitle2}
                                </p>

                                <div className="flex justify-end text-md">
                                    <a
                                        href="https://www.puna.gov.al/profili/punekerkues/shprehjeInteresi"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center gap-3 bg-[rgb(180,180,180)] text-white pl-2 px-3 py-2 rounded-2xl hover:bg-gray-400 transition duration-200"
                                    >
                                        <img
                                            src="/dual/I-logo.png"
                                            alt="Apply icon"
                                            className="w-6 h-6"
                                        />
                                        {language.button3}
                                    </a>
                                </div>
                            </div>


                        </div>

                    </div>




                    <div className="border-2 border-red-500 rounded-3xl p-6 mb-8">

                        <div className="flex gap-4 items-start">

                            <img
                                src="/dual/Picture4.png"
                                alt="Description"
                                className="w-[120px] h-[82px]"
                            />



                            <div>
                                <p className="text-red-600 font-extrabold text-lg">
                                    {language.title5}
                                </p>
                                <p className="mt-1">
                                    {language.subTitle3}
                                </p>


                                <div className="flex justify-end font-semibold text-md mt-4">
                                    <a
                                        href="https://e-albania.al/eAlbaniaServices/UseService.aspx?service_code=15266"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center gap-3 bg-red-600 text-white pl-2 px-4 py-1.5 rounded-2xl"
                                    >
                                        <img
                                            src="/dual/eAlbania_logo.867c8fb3.svg"
                                            alt="Apply icon"
                                            className="w-7 h-7"
                                        />
                                        {language.button4}
                                    </a>
                                </div>

                            </div>



                        </div>

                    </div>






                </section>
            </div>



        </section>
    )

}

export default withLanguage(EmploymentFilter, "EmploymentFilter");